export default "__VITE_ASSET__0647160a__"